var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpbnbWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4689 16.0012L8.48096 20.4221L12.2373 22.6325V25.2207L6.28259 21.7283V14.7085L8.4689 16.0012ZM8.4689 11.5804V14.1565L6.28125 12.8624V10.2863L8.4689 8.99219L10.6673 10.2863L8.4689 11.5804ZM13.8061 10.2863L15.9937 8.99219L18.1921 10.2863L15.9937 11.5804L13.8061 10.2863Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0488 19.5058V16.9176L12.2365 18.2117V20.7878L10.0488 19.5058ZM13.8052 23.5596L15.9929 24.8537L18.1912 23.5596V26.1357L15.9929 27.4298L13.8052 26.1357V23.5596ZM21.3287 10.2863L23.5163 8.99219L25.7147 10.2863V12.8624L23.5163 14.1565V11.5804L21.3287 10.2863ZM23.5163 20.4221L23.5284 16.0012L25.7161 14.7071V21.7269L19.7613 25.2194V22.6312L23.5163 20.4221Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9494 19.5062L19.7617 20.7882V18.2121L21.9494 16.918V19.5062Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9476 12.4963L21.9597 15.0845L18.1926 17.2949V21.7265L16.0049 23.0085L13.8173 21.7265V17.2949L10.0502 15.0845V12.4963L12.2472 11.2022L15.9915 13.4233L19.7586 11.2022L21.957 12.4963H21.9476ZM10.0488 8.07679L15.9929 4.57227L21.9476 8.07679L19.76 9.3709L15.9929 7.14975L12.2365 9.3709L10.0488 8.07679Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpbnbWhite);
export default __webpack_public_path__ + "static/media/opbnb-white.79cccc373d4ec70d88c0df639705b893.svg";
export { ForwardRef as ReactComponent };